module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }